import { trackEvent } from "@/utils/analytics/analytics";
import { NAVIGATION_CHANGED } from "@/utils/analyticsEvents";

export type PhoneType = "ireland" | "uk";

const EAP_DESTINATION = "eap";
const MINUTE_MS = 60 * 1000;

// Region labels are free text in Core ("IE", "ROI Freephone", "UK"), so match whole words.
const IRELAND_REGION = /\b(ie|irl|roi|ireland)\b/i;
const UK_REGION = /\b(uk|gb|gbr)\b/i;

export const toPhoneType = (region: string | null): PhoneType | null => {
  if (IRELAND_REGION.test(region ?? "")) return "ireland";
  if (UK_REGION.test(region ?? "")) return "uk";
  return null;
};

// Negative once the appointment has started.
export const minutesToStart = (
  startMs: number,
  nowMs: number = Date.now(),
): number => Math.round((startMs - nowMs) / MINUTE_MS);

// Accepts a route name ("eap") or path ("/eap?makecall=true"); every other destination is
// ignored, since entry into EAP is the only navigation the CR-460 schema tracks. Call it
// before $router.push, or page_key will already be the EAP page.
export const trackNavigationToEap = (
  destination: string,
  source: string,
  label: string,
): void => {
  const routeName = destination.replace(/^\//, "").split("?")[0];
  if (routeName !== EAP_DESTINATION) return;
  trackEvent(NAVIGATION_CHANGED, {
    source,
    destination: EAP_DESTINATION,
    label: label.trim(),
  });
};
